<script>
export default {
  name: 'HxDialogForm',
  data() {
    return {
      fullscreen: false,
      visible: false,
      title: '',
      formItemList: [],
      col: 3,
      formData: {},
      callback: null,
      labelPosition: 'right',
      cancelText: '取 消',
      confrimText: '确 定',
    }
  },
  methods: {
    handleClosed() {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
      this.callback('closed')
    },
    async handleConfirm() {
      await this.$refs.form.validate()
      this.visible = false
      this.callback('confirm')
    },
  },
  render() {
    return (
      <el-dialog
        width="80%"
        fullscreen={this.fullscreen}
        center={true}
        title={this.title}
        visible={this.visible}
        on={{ 'update:visible': (e) => (this.visible = e) }}
        onClosed={this.handleClosed}
      >
        <HxForm
          ref="form"
          col={this.col}
          label-position={this.labelPosition}
          formItemList={this.formItemList}
          vModel={this.formData}
        />
        <div slot="footer">
          <el-button onClick={() => (this.visible = false)}>{this.cancelText}</el-button>
          <el-button type="primary" onClick={this.handleConfirm}>{this.confrimText}</el-button>
        </div>
      </el-dialog>
    )
  },
}
</script>
